import { css } from "@microsoft/fast-element";
import { styles as textInputStyles } from "../text-input/text-input.styles.js";
import { colorNeutralForeground3, spacingHorizontalXS } from "@fluentui/web-components";
import { sizeHorizontalXL } from "@fabric-msft/theme";
export const styles = css `
  ${textInputStyles}

  .root {
    padding-inline-end: 0px;
  }

  .search-icon {
    display: flex;
    box-sizing: border-box;
    color: ${colorNeutralForeground3};
  }

  fabric-button.clear-button {
    min-width: ${sizeHorizontalXL};
    min-height: ${sizeHorizontalXL};
    margin-inline-end: ${spacingHorizontalXS};
    padding: 0px 2px;
    display: none;
  }
`;
//# sourceMappingURL=search-box.styles.js.map